import type {
  AssetTypeTemplateDuplicateFormProps,
  AssetTypeTemplateDuplicateFormValues,
} from "./asset-type-template-duplicate-form.type";
import type {
  EntityTemplateEntity,
  EntityTemplateDuplicateVariables,
} from "@/entities/entity-template";

import { useModelDuplicateForm } from "@/modules/model-duplicate";

export const useAssetTypeTemplateDuplicateForm = ({
  template,
}: AssetTypeTemplateDuplicateFormProps) => {
  return useModelDuplicateForm<
    EntityTemplateEntity,
    AssetTypeTemplateDuplicateFormValues,
    EntityTemplateDuplicateVariables
  >({
    modelKey: "technicalform",
    item: template,
    valuesToVariables: (values) => ({ name: values.name }),
    validationNames: ["name"],
  });
};
